export default __webpack_public_path__ + "static/headerBackground-19c3e84c12ef57b259158e1e2c68c490.png";